module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel slide",
    style: ({
      background: _vm.background,
      height: _vm.height
    }),
    on: {
      "mouseenter": _vm.pause,
      "mouseleave": _vm.start
    }
  }, [_c('ol', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indicators),
      expression: "indicators"
    }],
    staticClass: "carousel-indicators"
  }, _vm._l((_vm.slides.length), function(n) {
    return _c('li', {
      class: {
        active: n - 1 === _vm.index
      },
      on: {
        "click": function($event) {
          _vm.index = n - 1
        }
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.controls) ? [_c('a', {
    staticClass: "carousel-control-prev",
    attrs: {
      "href": "#",
      "role": "button",
      "data-slide": "prev"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.prev($event)
      }
    }
  }, [_c('span', {
    staticClass: "carousel-control-prev-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])]), _vm._v(" "), _c('a', {
    staticClass: "carousel-control-next",
    attrs: {
      "href": "#",
      "role": "button",
      "data-slide": "next"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.next($event)
      }
    }
  }, [_c('span', {
    staticClass: "carousel-control-next-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74ba11bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/carousel.vue
// module id = 246
// module chunks = 0